module.exports = __webpack_public_path__ + "img/horizontal-logo-white.e071faaf.svg";